// these conditions are used for conditional validations
// (if condition on target input true, apply validation to current input)
// example: if target input is not empty, make current input required
export enum FormConditionValidationEnum {
    IsNotEmpty = "is-not-empty",
    IsEmpty = "is-empty"
}
